import React, { Component } from "react";
import Select from "react-select";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import Cx from "classnames";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import Delete from "../../../../assets/images/delete.svg";
import ACTIONS from "../../../../common/action_constant";

class AddActionMaster extends Component {
  sapSearchTimeout = null;
  subSapSearchTimeout = null;
  constructor(props) {
    super(props);
    this.state = {
      data: {
        action_type: this.props.editData ? this.props.editData.action_type : "",
        action_name: this.props.editData ? this.props.editData.action_name : "",
        action_id: this.props.editData ? this.props.editData.action_id : "",
        integration_id: this.props.editData
          ? this.props.editData.integration_id
          : "",
        integration_name: this.props.editData
          ? this.props.editData.integration_name
          : "",
        interface_id: this.props.editData
          ? this.props.editData.interface_id
          : "",
        sub_action: this.props.editData
          ? (this.props.editData.sub_action || []).map((sa) => ({
              sub_action_id: sa.sub_action_id || "",
              sub_action_name: sa.sub_action_name || "",
              sub_action_type: sa.sub_action_type || "",
              sub_integration_id: sa.sub_integration_id || "",
              sub_interface_id: sa.sub_interface_id || "",
              sub_integration_name: sa.sub_integration_name || "",
            }))
          : [],
        company_id: this.props.editData
          ? this.props.editData.company_id
          : this.props.companyId,
      },
    };
  }

  componentDidMount() {
    setItemToSessionStorage(
      "previousActionConfigurationData",
      this.props.editData
    );
  }

  addSubActionRow = () => {
    let { data } = this.state;
    data.sub_action.push({
      sub_action_id: "",
      sub_action_name: "",
      sub_action_type: "",
      sub_integration_id: "",
      sub_interface_id: "",
      sub_integration_name: "",
    });

    this.setState({ data });
  };

  onSelectSubAction = (index, option) => {
    let { data } = this.state;

    data.sub_action[index].sub_action_id = option.sub_action_id;
    data.sub_action[index].sub_action_name = option.sub_action_name;
    data.sub_action[index].sub_action_type = option.sub_action_type;

    this.setState({ data });
  };

  onSelectSubActionSAP = (index, option) => {
    let { data } = this.state;

    data.sub_action[index].sub_integration_id = option.value;
    data.sub_action[index].sub_interface_id = option.interface_id;
    data.sub_action[index].sub_integration_name = option.label;

    this.setState({ data });
  };

  removeSubActionRow = (index) => {
    let { data } = this.state;

    const updated = [...data.sub_action];
    updated.splice(index, 1);

    this.setState({
      data: {
        ...data,
        sub_action: updated,
      },
    });
  };

  onChangeHandler = (option) => {
    let { data } = this.state;
    data.action_type = option.action_type;
    data.action_name = option.label;
    data.action_id = option.action_id;
    this.setState({ data });
  };

  onSave = () => {
    const { data } = this.state;
    this.props.onSave(data);
  };

  onUpdate = () => {
    const { data } = this.state;
    this.props.onUpdate(data);
  };

  onChangeSubAction = (selectedOptions) => {
    let { data } = this.state;
    data.sub_action = selectedOptions.map((opt) => ({
      sub_action_type: opt.sub_action_type,
      sub_action_name: opt.sub_action_name,
      sub_action_id: opt.sub_action_id,
      sub_integration_id: opt.sub_integration_id,
      sub_interface_id: opt.sub_interface_id,
    }));

    this.setState({ data });
  };

  onChangeSapDetails = (e) => {
    let { data } = this.state;
    data.integration_id = e.value;
    data.integration_name = e.label;
    data.interface_id = e.interface_id;
    this.setState({ data });
  };

  render() {
    const { data } = this.state;
    let optionActionType = [];
    let optionSubAction = [];
    let optionSapConfig = [];

    if (this.props.actionlistDropdown) {
      optionActionType = this.props.actionlistDropdown.map((item) => ({
        value: item.action_id,
        label: item.name,
        action_type: item.type,
        action_name: item.name,
        action_id: item.action_id,
      }));
    }
    if (this.props.actionlistDropdown) {
      optionSubAction = this.props.actionlistDropdown.map((item) => ({
        value: item.action_id,
        label: item.name,
        sub_action_type: item.type,
        sub_action_name: item.name,
        sub_action_id: item.action_id,
      }));
    }

    if (this.props.sapListData) {
      optionSapConfig = this.props.sapListData.map((item) => ({
        value: item.integration_id,
         label: item.name,
        interface_id: item.interface_id,
      }));
    }

    const disable = !data.action_type;

    return (
      <div className="route_code_detail">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup" style={{ minHeight: "600px" }}>
          <div className="pop-heading">
            {`${this.props.editData ? "Edit" : "Add"} Action Master`}
          </div>
          <div className="route-detail">
            <div
              className="details-section"
              style={{ display: "flex", gap: "30px" }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">
                  Action Type <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={optionActionType}
                  value={optionActionType.find(
                    (val) => val.value == data.action_id
                  )}
                  onChange={(e) => this.onChangeHandler(e)}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">SAP Integration</div>
                <Select
                  className={Cx("selectpack")}
                  options={optionSapConfig}
                  value={optionSapConfig.find(
                    (val) => val.value == data.integration_id
                  )}
                  onChange={(e) => this.onChangeSapDetails(e)}
                  filterOption={() => true}
                  onInputChange={(inputValue, { action }) => {
                    if (action !== "input-change") return inputValue;

                    if (this.sapSearchTimeout) {
                      clearTimeout(this.sapSearchTimeout);
                    }
                    const currentLength = inputValue.length;
                    const previousLength = this.prevInputLength || 0;
                    if (currentLength < previousLength) {
                      this.backspaceCount = (this.backspaceCount || 0) + 1;
                    } else {
                      this.backspaceCount = 0;
                    }
                    this.prevInputLength = currentLength;
                    this.sapSearchTimeout = setTimeout(() => {
                      if (currentLength >= 3 && currentLength > previousLength) {
                        this.props.fetchSapList(inputValue);
                      }
                      if (
                        this.backspaceCount >= 3 &&
                        (currentLength >= 3 || currentLength === 0)
                      ) {
                        this.props.fetchSapList(inputValue);
                        this.backspaceCount = 0;
                      }
                    }, 500);
                    return inputValue;
                  }}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <Button value="Add Sub Action" click={this.addSubActionRow} />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
              }}
            >
              <div className="label">Sub Actions</div>

              {data.sub_action.map((sa, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    gap: "20px",
                    marginBottom: "15px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "250px" }}>
                    <Select
                      className={Cx("selectpack")}
                      options={optionSubAction}
                      value={optionSubAction.find(
                        (opt) => opt.sub_action_id == sa.sub_action_id
                      )}
                      onChange={(option) =>
                        this.onSelectSubAction(index, option)
                      }
                    />
                  </div>

                  <div style={{ width: "250px" }}>
                    <Select
                      className={Cx("selectpack")}
                      options={optionSapConfig}
                      value={optionSapConfig.find(
                        (opt) => opt.value == sa.sub_integration_id
                      )}
                      onChange={(option) =>
                        this.onSelectSubActionSAP(index, option)
                      }
                      filterOption={() => true}
                      onInputChange={(inputValue) => {
                        clearTimeout(this.subSapSearchTimeout);
                        this.subSapSearchTimeout = setTimeout(() => {
                          this.props.fetchSapList(inputValue);
                        }, 500);
                        return inputValue;
                      }}
                    />
                  </div>

                  <div
                    className={"action-icon"}
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.removeSubActionRow(index)}
                  />
                </div>
              ))}
            </div>

            <div className={"button_route"} style={{ marginTop: "50px" }}>
              <Button value={"Cancel"} click={this.props.toggleAdd} />
              {!this.props.editData ? (
                <Button value={"Save"} click={this.onSave} disabled={disable} />
              ) : (
                <Button
                  value={"Update"}
                  click={this.onUpdate}
                  disabled={disable}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddActionMaster;
